/* Twenty-Four Diet — theme scripts (no dependencies) */
(function () {
  'use strict';
  var theme = window.theme || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function parseStart() {
    var parts = String(theme.adventStart || '2026-12-01').split('-').map(Number);
    return new Date(parts[0], (parts[1] || 12) - 1, parts[2] || 1);
  }

  function formatMoney(cents) {
    var format = theme.moneyFormat || '${{amount}}';
    var value = (cents / 100);
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      var fixed = value.toFixed(2);
      if (key === 'amount_no_decimals') return Math.round(value).toLocaleString('en-US');
      if (key === 'amount_with_comma_separator') return fixed.replace('.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return Math.round(value).toLocaleString('de-DE');
      return Number(fixed).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }

  /* ---------- Countdowns ---------- */
  function initCountdowns(root) {
    $$('[data-countdown]', root).forEach(function (el) {
      if (el._cd) return; el._cd = true;
      var raw = el.getAttribute('data-target') || theme.adventStart;
      var p = String(raw).split('-').map(Number);
      var target = new Date(p[0], (p[1] || 12) - 1, p[2] || 1).getTime();
      var d = $('[data-d]', el), h = $('[data-h]', el), m = $('[data-m]', el), s = $('[data-s]', el);
      var pad = function (n) { return String(n).padStart(2, '0'); };
      function tick() {
        var diff = target - Date.now();
        if (isNaN(target) || diff <= 0) {
          el.classList.add('is-done');
          var label = $('[data-countdown-label]', el);
          if (label && el.dataset.done) label.textContent = el.dataset.done;
          clearInterval(timer);
          return;
        }
        d.textContent = Math.floor(diff / 864e5);
        h.textContent = pad(Math.floor(diff / 36e5) % 24);
        m.textContent = pad(Math.floor(diff / 6e4) % 60);
        s.textContent = pad(Math.floor(diff / 1e3) % 60);
      }
      var timer = setInterval(tick, 1000); tick();
    });
  }

  /* ---------- Header / mobile nav ---------- */
  function initHeader() {
    var toggle = $('[data-menu-toggle]'), nav = $('[data-mobile-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = nav.hidden;
      nav.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawerEl = function () { return $('[data-cart-drawer]'); };
  function openDrawer() {
    var d = drawerEl(); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var close = $('[data-drawer-close].header__icon', d); if (close) close.focus();
  }
  function closeDrawer() {
    var d = drawerEl(); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
  }
  function refreshDrawer(sectionsHtml) {
    var apply = function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var fresh = $('[data-cart-drawer]', tmp), current = drawerEl();
      if (fresh && current) {
        var wasOpen = current.classList.contains('is-open');
        current.innerHTML = fresh.innerHTML;
        if (wasOpen) current.classList.add('is-open');
      }
    };
    if (sectionsHtml && sectionsHtml['cart-drawer']) { apply(sectionsHtml['cart-drawer']); return Promise.resolve(); }
    return fetch((theme.routes.root || '/') + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j['cart-drawer']) apply(j['cart-drawer']); });
  }
  function changeLine(line, quantity) {
    var d = drawerEl(); if (d) d.classList.add('is-loading');
    return fetch(theme.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)), sections: ['cart-drawer'] })
    }).then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count || 0);
        if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
        return refreshDrawer(cart.sections).then(function () { initPreorder(drawerEl()); });
      })
      .finally(function () { var dd = drawerEl(); if (dd) dd.classList.remove('is-loading'); });
  }

  function initCart() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-cart-toggle]') && drawerEl() && !document.body.classList.contains('template-cart')) {
        e.preventDefault(); openDrawer(); return;
      }
      if (t.closest('[data-drawer-close]')) {
        var link = t.closest('a[data-drawer-close]');
        if (!link || link.getAttribute('href') === '#') e.preventDefault();
        closeDrawer(); return;
      }
      var lc = t.closest('[data-line-change]');
      if (lc) { e.preventDefault(); changeLine(lc.dataset.lineChange, lc.dataset.qtyTo); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  /* ---------- Product forms ---------- */
  function initProduct(info) {
    if (info._init) return; info._init = true;
    var form = $('[data-product-form]', info);
    var idInput = form && $('[data-variant-id]', form);
    var picker = $('[data-variant-picker]', info);
    var variants = [];
    if (picker) { try { variants = JSON.parse($('[data-variants]', picker).textContent); } catch (err) {} }
    var section = info.closest('.product-section') || document;
    var gallery = $('[data-gallery]', section);

    /* Gallery */
    function showMedia(id) {
      if (!gallery || !id) return;
      $$('.gallery__slide', gallery).forEach(function (s) { s.classList.toggle('is-active', s.dataset.mediaId == id); });
      $$('[data-thumb]', gallery).forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb == id); });
    }
    if (gallery && !gallery._init) {
      gallery._init = true;
      gallery.addEventListener('click', function (e) {
        var th = e.target.closest('[data-thumb]'); if (th) showMedia(th.dataset.thumb);
      });
    }

    /* Variants */
    if (picker && variants.length) {
      picker.addEventListener('change', function () {
        var selected = $$('input[type=radio]:checked', picker).map(function (i) { return i.value; });
        $$('[data-option-value]', picker).forEach(function (el) { el.textContent = selected[Number(el.dataset.optionValue)] || ''; });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === selected[i]; }); });
        var btn = $('[data-add-button]', info), label = $('[data-add-text]', info);
        if (!v) { if (btn) btn.disabled = true; if (label) label.textContent = 'Unavailable'; return; }
        if (idInput) idInput.value = v.id;
        if (btn) btn.disabled = !v.available;
        if (label) label.textContent = v.available ? (btn.dataset.label || (btn.dataset.label = label.textContent === 'Sold out' || label.textContent === 'Unavailable' ? 'Add to cart' : label.textContent)) : 'Sold out';
        var price = $('[data-price]', info);
        if (price) {
          var html = '<span class="price__current">' + formatMoney(v.price) + '</span>';
          if (v.compare_at_price > v.price) {
            html += '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>' +
              '<span class="price__badge">Save ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%</span>';
          }
          price.innerHTML = html;
          price.classList.toggle('price--sale', v.compare_at_price > v.price);
        }
        if (v.featured_media) showMedia(v.featured_media.id);
        if (document.body.classList.contains('template-product')) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }
      });
    }

    /* Quantity */
    var qty = $('[data-qty]', info);
    if (qty) {
      var input = $('input', qty);
      $('[data-qty-minus]', qty).addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      $('[data-qty-plus]', qty).addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    }

    /* Add to cart */
    if (form && theme.cartDrawer && drawerEl()) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = $('[data-add-button]', form), err = $('[data-form-error]', form);
        btn.disabled = true; btn.classList.add('is-loading');
        if (err) err.hidden = true;
        var fd = new FormData(form);
        fd.append('sections', 'cart-drawer');
        fd.append('sections_url', window.location.pathname);
        fetch(theme.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
            return refreshDrawer(res.body.sections).then(function () {
              return fetch(theme.routes.cart + '.js').then(function (r) { return r.json(); });
            }).then(function (cart) { setCount(cart.item_count); initPreorder(drawerEl()); openDrawer(); });
          })
          .catch(function (ex) { if (err) { err.textContent = ex.message; err.hidden = false; } })
          .finally(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
      });
    }
  }

  /* ---------- Advent door game ---------- */
  function initDoors(root) {
    $$('[data-doors]', root).forEach(function (wrap) {
      if (wrap._init) return; wrap._init = true;
      var preview = wrap.dataset.preview === 'true';
      var startStr = wrap.dataset.start || theme.adventStart;
      var p = String(startStr).split('-').map(Number);
      var start = new Date(p[0], (p[1] || 12) - 1, p[2] || 1);
      var today = new Date(); today.setHours(0, 0, 0, 0);
      var dayIndex = Math.floor((today - start) / 864e5) + 1; // 1 on day one
      var key = 'ddp-doors-' + start.getFullYear();
      var opened = [];
      try { opened = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) {}
      var toast = $('[data-doors-toast]', wrap);
      var say = function (msg) { if (toast) toast.textContent = msg; };

      $$('[data-door]', wrap).forEach(function (door) {
        var n = Number(door.dataset.door);
        var unlocked = preview || n <= dayIndex;
        if (n === dayIndex) door.classList.add('is-today');
        if (opened.indexOf(n) > -1 && unlocked) { door.classList.add('is-open'); door.setAttribute('aria-pressed', 'true'); }
        door.addEventListener('click', function () {
          if (!unlocked) {
            door.classList.remove('shake'); void door.offsetWidth; door.classList.add('shake');
            var wait = new Date(start.getTime() + (n - 1) * 864e5);
            say('No peeking! Door ' + n + ' opens on ' + wait.toLocaleDateString(undefined, { month: 'long', day: 'numeric' }) + '.');
            return;
          }
          var isOpen = door.classList.toggle('is-open');
          door.setAttribute('aria-pressed', String(isOpen));
          if (isOpen) {
            if (opened.indexOf(n) === -1) opened.push(n);
            var prize = $('.door__prize', door);
            say('Door ' + n + ': ' + (prize ? prize.textContent.trim() : 'surprise!') + ' 🎉');
          } else {
            opened = opened.filter(function (x) { return x !== n; });
          }
          try { localStorage.setItem(key, JSON.stringify(opened)); } catch (e) {}
        });
      });
    });
  }

  /* ---------- Reviews ---------- */
  function initReviews(root) {
    $$('[data-reviews]', root).forEach(function (wrap) {
      if (wrap._init) return; wrap._init = true;
      var list = $('[data-reviews-list]', wrap); if (!list) return;
      var pageSize = Number(wrap.dataset.pageSize) || 6;
      var more = $('[data-load-more]', wrap), sort = $('[data-sort]', wrap);
      var filter = 'all', shown = pageSize;
      var items = $$('.review', list);
      function render() {
        var sorted = items.slice();
        var mode = sort ? sort.value : 'newest';
        sorted.sort(function (a, b) {
          if (mode === 'highest') return b.dataset.rating - a.dataset.rating;
          if (mode === 'lowest') return a.dataset.rating - b.dataset.rating;
          if (mode === 'photos') return b.dataset.photo - a.dataset.photo;
          return (b.dataset.date || '').localeCompare(a.dataset.date || '');
        });
        var visible = 0, matching = 0;
        sorted.forEach(function (el) {
          list.appendChild(el);
          var ok = filter === 'all' || el.dataset.rating === filter;
          if (ok) matching++;
          el.hidden = !(ok && visible < shown);
          if (ok && visible < shown) visible++;
        });
        if (more) more.hidden = matching <= shown;
      }
      wrap.addEventListener('click', function (e) {
        var f = e.target.closest('[data-filter]'); if (!f) return;
        filter = f.dataset.filter; shown = pageSize;
        $$('.chip[data-filter]', wrap).forEach(function (c) { c.classList.toggle('is-active', c.dataset.filter === filter); });
        render();
      });
      if (sort) sort.addEventListener('change', function () { shown = pageSize; render(); });
      if (more) more.addEventListener('click', function () { shown += pageSize; render(); });
      render();
    });
  }

  /* ---------- Snow ---------- */
  function initSnow() {
    var snow = $('.snow'); if (!snow || snow.childElementCount) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var count = window.innerWidth < 700 ? 18 : 36;
    for (var i = 0; i < count; i++) {
      var f = document.createElement('i');
      var size = 3 + Math.random() * 5;
      f.style.cssText = 'left:' + (Math.random() * 100) + '%;width:' + size + 'px;height:' + size + 'px;opacity:' + (0.4 + Math.random() * 0.5) +
        ';animation-duration:' + (8 + Math.random() * 12) + 's;animation-delay:-' + (Math.random() * 20) + 's;--drift:' + (Math.random() * 80 - 40) + 'px';
      snow.appendChild(f);
    }
  }

  /* ---------- Pre-order dates (re-checked in the browser so cached pages stay accurate) ---------- */
  function initPreorder(root) {
    var po = theme.preorder; if (!po || !po.enabled) return;
    var day = 864e5, week = 7 * day;
    var minW = Number(po.minWeeks) || 4, maxW = Math.max(minW, Number(po.maxWeeks) || 6);
    var p = String(po.christmas || '2026-12-25').split('-').map(Number);
    var xmas = new Date(p[0], (p[1] || 12) - 1, p[2] || 25).getTime();
    var cutoff = xmas - maxW * week;          // last day that guarantees delivery
    var maybe = xmas - minW * week;           // after this, Christmas delivery is impossible
    var now = Date.now();
    var fmt = function (t, long) { return new Date(t).toLocaleDateString('en-US', { month: long ? 'long' : 'short', day: 'numeric' }); };
    var eta = fmt(now + minW * week) + ' – ' + fmt(now + maxW * week);
    $$('[data-eta]', root).forEach(function (el) { el.textContent = eta; });
    $$('[data-order-by]', root).forEach(function (el) { el.textContent = fmt(cutoff, true); });
    var stage = now < cutoff + day ? 'ontime' : (now < maybe ? 'maybe' : 'late');
    $$('[data-preorder] [data-stage]', root).forEach(function (el) { el.hidden = el.dataset.stage !== stage; });
  }

  function initAll(root) {
    initPreorder(root);
    initCountdowns(root);
    $$('[data-product-info]', root).forEach(initProduct);
    initDoors(root);
    initReviews(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader(); initCart(); initSnow(); initAll(document);
  });
  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
